export default __webpack_public_path__ + "static/media/noodlehead.1deb57ed.jpeg";